import { StyleObject } from '../types';

export function isMobile(): boolean {
  return /Android|webOS|iPhone|iPod|iPad|iPad Pro|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function isAndroid(): boolean {
  return /Android/i.test(navigator.userAgent);
}

// TODO: Refactor to use getStyleObjectFromUrl and remove this function
export const getStyleObject = (model: any, field: string): StyleObject => {
  if (model) {
    if (model[field]) {
      return getStyleObjectFromUrl(model[field]);
    }
  }
  return {};
};

export const getStyleObjectFromUrl = (img: string): StyleObject => {
  const imgStyle: StyleObject = {};
  if (img) {
    imgStyle.backgroundImage = `url(${img})`;
  }
  return imgStyle;
};
